import {
  ADD_TRUCK_TYPE_FAIL,
  ADD_TRUCK_TYPE_REQUEST,
  ADD_TRUCK_TYPE_SUCCESS,
  DELETE_TRUCK_TYPE_FAIL,
  DELETE_TRUCK_TYPE_REQUEST,
  DELETE_TRUCK_TYPE_SUCCESS,
  GET_TRUCK_TYPE_LIST_FAIL,
  GET_TRUCK_TYPE_LIST_REQUEST,
  GET_TRUCK_TYPE_LIST_SUCCESS,
  GET_SINGLE_TRUCK_TYPE_FAIL,
  GET_SINGLE_TRUCK_TYPE_REQUEST,
  GET_SINGLE_TRUCK_TYPE_SUCCESS,
  UPDATE_TRUCK_TYPE_FAIL,
  UPDATE_TRUCK_TYPE_REQUEST,
  UPDATE_TRUCK_TYPE_SUCCESS,
} from "src/constants/types";

export const truckTypeReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_TRUCK_TYPE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_TRUCK_TYPE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        truckTypes: actions.payload,
        error: "",
      };
    case GET_TRUCK_TYPE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_TRUCK_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_TRUCK_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_TRUCK_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_TRUCK_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_TRUCK_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_TRUCK_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_TRUCK_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_TRUCK_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        truckType: actions.payload,
      };
    case GET_SINGLE_TRUCK_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_TRUCK_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_TRUCK_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_TRUCK_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
